import React from 'react';
import { Checkbox, IconButton, Typography } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

/* eslint-disable import/prefer-default-export */
const TitleStyle = {
  fontSize: '12px',
  fontWeight: 500,
  borderBottom: 'none',
  textTransform: 'uppercase',
  background: '#e4e7ea',
  font: 'normal normal 600 10px Montserrat',
  letterSpacing: 0,
  color: '#707070',
  padding: '16px 8px',
};
const defaultColumnStyle = {
  font: 'normal normal 600 14px Montserrat',
  letterSpacing: 0,
  color: '#38485C',
  marginLeft: 5,
};
export const columns = (onHandleActions, selection) => ([
  {
    id: 'id',
    label: '',
    // same side padding as the body cells, so header and row checkboxes line up
    style: { ...TitleStyle, padding: '16px 3px' },
    renderHeader: () => (
      <Checkbox
        size="small"
        checked={selection.allChecked}
        indeterminate={selection.someChecked}
        onChange={selection.toggleAll}
      />
    ),
    render: ({ value }) => (
      <Checkbox
        size="small"
        checked={selection.isChecked(value)}
        onChange={() => selection.toggleRow(value)}
      />
    ),
  },
  {
    id: 'reference',
    label: 'Référence',
    style: TitleStyle,
    render: ({ value }) => <Typography style={defaultColumnStyle}>{value}</Typography>,
  },
  {
    id: 'brand',
    label: 'Marque',
    style: TitleStyle,
    render: ({ value }) => <Typography style={defaultColumnStyle}>{value}</Typography>,
  },
  {
    id: 'family',
    label: 'Famille',
    style: TitleStyle,
    render: ({ value }) => <Typography style={defaultColumnStyle}>{value}</Typography>,
  },
  {
    id: 'minQte',
    label: 'Qté min',
    style: TitleStyle,
    render: ({ value }) => <Typography style={defaultColumnStyle}>{value}</Typography>,
  },
  {
    id: 'maxQte',
    label: 'Qté max',
    style: TitleStyle,
    render: ({ value }) => <Typography style={defaultColumnStyle}>{value}</Typography>,
  },
  {
    id: 'remise',
    label: 'Remise (%)',
    style: TitleStyle,
    render: ({ value }) => <Typography style={defaultColumnStyle}>{value}</Typography>,
  },
  {
    id: 'price',
    label: 'Prix spécial',
    style: TitleStyle,
    render: ({ value }) => <Typography style={defaultColumnStyle}>{value}</Typography>,
  },
  {
    id: 'client',
    label: 'Client spécifique',
    style: TitleStyle,
    render: ({ value }) => <Typography style={defaultColumnStyle}>{value}</Typography>,

  },
  {
    id: 'action',
    label: '',
    style: TitleStyle,
    render: ({ row }) => (
      <IconButton aria-label="actions" size="large" onClick={(e) => onHandleActions(row)(e)}>
        <MoreHorizIcon />
      </IconButton>
    ),
  },
]);
